module.exports = __webpack_public_path__ + "static/media/downArrow.56350e18.svg";